import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSelectionListValue } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for creating a Selection List Value.
 */
export const useCreateSelectionListValue = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call createSelectionListValue.
     * @param {Pella.ProductionRequestAPI.CreateSelectionListValueInput} input - The inputs for creating the Selection List Value.
     */
    mutationFn: (input) => createSelectionListValue(input),
    onSuccess: () => {
      toast.success('Selection List Value created successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SELECTION_LISTS] });
    },
  });
};
